<template id="sitesTmpl">
	<ct-main-layout-appadmin :backurl="backurl" :breadcrumbs="breadcrumbs" >

		<v-card>
			<!-- TITLE -->
			<v-card-title>
				{{detailOrg.organization_name}}
			</v-card-title>

			<v-card-text>	
				<v-row no-gutters>
					<v-col cols="12">
						<v-btn class="button-main ma-1"  v-on:click="openNewSite()"><v-icon left dark>add</v-icon>{{ $t('btn.addSite')}}</v-btn>
					</v-col>
				</v-row>
			</v-card-text>

			<v-divider></v-divider>	
		
			<v-card-text>
				<v-data-table v-if="sitesList != null && sitesList != []"  :headers="headersSites"  :items="sitesList"  :no-data-text="$t('err.noelem')"  :loading="$root.loading"  class="elevation-1">
					<template v-slot:body="{ items }">
						<tbody>
							<tr v-for="item in items" :key="item.site_id" >
								<td>
									<v-icon class="inactiveIcon mr-2" v-if="item.flags == null || (item.flags !=null && item.flags.active != true)">visibility_off</v-icon>
									<v-icon v-if="item.alert" class="alertIcon mr-2">mdi-alert</v-icon>
									<strong>{{ item.site_name }}</strong>
								</td>
								<td width="20%" class="text-right">
									<v-tooltip top> 
										<template v-slot:activator="{ on, attrs }">
											<v-btn 
												class="button-secondary" fab small depressed
												v-bind="attrs"
												v-on="on" 
												@click="$root.goToPage('/appadmin/site/'+item.organization_id+'/' + item.site_id)"
											><v-icon>create</v-icon></v-btn>
										</template>
										<span>{{ $t('btn.edit')}}</span>
									</v-tooltip>	
								</td>
							</tr>
						</tbody>
					</template>
				</v-data-table>

				<div v-else>{{$t('err.noSitesFound')}}</div>

			</v-card-text>
		</v-card>	

		<!-- MIDDLEWARE -->
		<v-card class="mb-2">	
			<v-card-title>{{$t('lbl.middleware')}}</v-card-title>

			<v-card-text>
				<v-row no-gutters>
					<v-col cols="12">
						<strong>{{$t('lbl.middlewareCommonCalls')}}</strong>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col cols="12">	
						<v-btn class="button-secondary ma-1" v-on:click="gotoGatewaySitesListAlert()" >{{$t('btn.gatewaySitesListWithAlert')}}</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>	

		<ct-dialog-edit-site ref="editSiteDlg" :site2edit="site2edit"></ct-dialog-edit-site>
		
	</ct-main-layout-appadmin>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';
import ctDialogEditSite from '@/components/appadmin/ctDialogEditSite.vue';

export default {
	i18n,
	data: () => ({
		backurl: '/appadmin',
		breadcrumbs:[],
		detailOrg: null,
		headersSites: [
			{ text: i18n.t('lbl.sites'), align: 'left', value: 'site_name'},
			{ text: '', align: 'center'},
		],
		sitesList: [],
		site2edit: null,
	}),
	components: 
	{
      'ct-dialog-edit-site': ctDialogEditSite,
	},
	created(){
		this.detailOrg = this.getEmptyOrgGuiAdmin();
	},
	mounted() 
	{
		//=== BLOCCO LA PAGINA
		this.$root.globalPageLoading = true;

		//=== NAVIGATION BAR
		this.breadcrumbs = [
			{ text: i18n.t('breadcrumb.appadmin'), disabled: false, href: '/tools/appadmin' }
		]

		//=== START LISTEN EVENTS
		events.$on(constants.EVENT_DO_LOAD_SITE_LIST, () => {
			this.loadSitesList();			
		});
		
		events.$on(constants.EVENT_CHANGE_LOCALE, () => {
			this.headersSites = [
				{ text: i18n.t('lbl.sites'), align: 'left', value: 'site_name'},
				{ text: '', align: 'center'},
			];
		});

		//=== STARTUP
		this.loadOrgDetails();
	},
	destroyed() 
	{
		//=== STOP LISTEN EVENTS
		events.$off(constants.EVENT_DO_LOAD_SITE_LIST);
		events.$off(constants.EVENT_CHANGE_LOCALE);
	},
	methods: 
	{
		loadOrgDetails() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			}
			else 
			{
				var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadOrgDetails, 'err.loadingOrg');
			}
		},
		callbackLoadOrgDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.detailOrg = responseData;
				
				this.breadcrumbs.push({text: this.detailOrg.organization_name, disabled: false});

				this.loadSitesList();
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingOrg"));
			}	
		},
		loadSitesList() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			}
			else 
			{
				this.sitesList = [];
				//var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId + '/sites';
				
				var endpoint2go = constants.ENDPOINT_GATEWAY_SITES_LIST_ALERT;
				endpoint2go += "?org=" + this.$route.params.orgId;
				
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadSitesList, 'err.loadingSites');
			}
		},
		callbackLoadSitesList(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.sitesList = this.getSecureSiteList(responseData, false);

				//=== SBLOCCO LA PAGINA
				this.$root.globalPageLoading = false;
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingSites"));
			}
		},
		openNewSite()
		{
			this.site2edit = this.getEmptySite();
			this.$refs.editSiteDlg.openEditSite();
		},
		deleteSite(siteId)
		{
			if(!this.isEmptyString(siteId))
			{
				if(confirm(i18n.t('lbl.site') + " " +siteId + " - " + i18n.t('msg.confirmDelete')))
				{
					alert("FUNZIONE DA IMPLEMENTARE");
				}
			}
		},
		gotoGatewaySitesListAlert(){
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else 
			{
				var url2go = constants.ENDPOINT_GATEWAY_SITES_LIST_ALERT;
				url2go += "?org=" + this.$route.params.orgId;
				url2go += "&accessToken=" + this.getUserAccessToken();
				//=== ACCESS TOKEN PRIMA LO CERCA NEGLI HEADERS SE NON LO TROVA LO CERCA IN GET
				window.open(url2go);
			}
		}			
	}
}
</script>